import ErrorBox from './errorbox';

export default ErrorBox;
